import {
  ensureArrayOfStrings,
  ensureObject,
  ensureString,
} from "../validate";
import { getTicketId } from "./ticket";

const FN = "GZIntegracoes.v1.privacyConsent";

interface SDKPrivacyInstance {
  termsOfUseHash: string;
  privacyPolicyHash: string;
  promotionOffersHash: string;
  addHolder(holder: string): void;
  addHash(hashes: string[]): void;
  addConsentMetadata(metadata: Array<{ name: string; value: string }>): void;
  consent(value: boolean): Promise<unknown>;
}

interface SDKPrivacyConstructor {
  new (): SDKPrivacyInstance;
}

declare global {
  interface Window {
    SDKPrivacy?: SDKPrivacyConstructor;
  }
}

export interface PrivacyConsentParams {
  holder: string;
  hashes?: string[];
  metadata?: Record<string, string | null | undefined>;
}

export async function privacyConsent(params: PrivacyConsentParams): Promise<boolean> {
  ensureObject(params, `${FN}(params)`);
  ensureString(params.holder, `${FN} → params.holder`);
  if (params.hashes !== undefined) {
    ensureArrayOfStrings(params.hashes, `${FN} → params.hashes`);
  }
  if (params.metadata !== undefined && params.metadata !== null) {
    ensureObject(params.metadata, `${FN} → params.metadata`);
  }

  const SDKPrivacy = window.SDKPrivacy;
  if (typeof SDKPrivacy !== "function") {
    throw new Error(
      `${FN}: window.SDKPrivacy não está disponível. Carregue a lib SDKPrivacy na página antes de chamar essa função.`,
    );
  }

  try {
    const sdk = new SDKPrivacy();
    sdk.addHolder(params.holder);

    const inferredMetadata: Record<string, string | null | undefined> = {
      pageUrl: window.location.href,
      ticketId: getTicketId(),
      ...params.metadata,
    };
    const metadata: Array<{ name: string; value: string }> = [];
    for (const [name, value] of Object.entries(inferredMetadata)) {
      if (typeof value === "string" && value.length > 0) {
        metadata.push({ name, value });
      }
    }
    if (metadata.length > 0) {
      sdk.addConsentMetadata(metadata);
    }

    sdk.addHash([
      ...(params.hashes ?? []),
      sdk.termsOfUseHash,
      sdk.privacyPolicyHash,
      sdk.promotionOffersHash,
    ]);

    await sdk.consent(true);
    return true;
  } catch {
    return false;
  }
}
